module.exports = __webpack_public_path__ + "img/bg-mision-1-1.a8ce47e6.jpg";